import { API_HOST } from "app/utils/constants/paths";
import baseAxios from "axios";

const axios = baseAxios.create({
    baseURL: API_HOST,
    headers: {
        'Content-Type': 'application/json'
    }
});

//todo: define interceptors and other configuration like baseURL, headers etc. here
export default axios;